
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7cfqh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0bebafd0f08660fa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $0bebafd0f08660fa$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': "A\xe7\xf5es",
    'ai-smart-button.ai-actions.give-feedback-action.title': 'Dar feedback',
    'ai-smart-button.ai-actions.help.section.text': 'Ajuda',
    'ai-smart-button.ai-actions.input.link-picker-button-label': 'Link',
    'ai-smart-button.ai-actions.input.mention-button-label': 'Mencionar',
    'ai-smart-button.ai-actions.input.send-button-label': 'Enviar',
    'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
    'ai-smart-button.ai-actions.item.newLozenge': 'NOVIDADE',
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "Adicionar \xedcone",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "\xcdcone de automa\xe7\xe3o",
    'ai-smart-button.ai-actions.rovo-agents.automations.text': "Automa\xe7\xf5es",
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Pesquisar agentes',
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "Criar automa\xe7\xe3o",
    'ai-smart-button.ai-actions.rovo-agents.section.text': "Est\xfadio",
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Oi, {name},',
    'ai-smart-button.ai-proactive-nudge.dismiss': 'Ignorar',
    'ai-smart-button.feedback-action.ask-question-option': "Fa\xe7a uma pergunta",
    'ai-smart-button.feedback-action.cancel-button-label': 'Cancelar',
    'ai-smart-button.feedback-action.choose-feedback-option': 'Escolha um',
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Descrever o bug ou item',
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "Deixe a gente saber sua opini\xe3o",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "O que voc\xea gostaria de saber?",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "Conte para a gente o que voc\xea acha que pode melhorar",
    'ai-smart-button.feedback-action.feedback-modal-heading': 'Compartilhe suas ideias',
    'ai-smart-button.feedback-action.leave-comment-option': "Deixar um coment\xe1rio",
    'ai-smart-button.feedback-action.report-bug-option': 'Reportar um problema',
    'ai-smart-button.feedback-action.research-participation-message': 'Eu gostaria de participar da pesquisa de produtos',
    'ai-smart-button.feedback-action.select-feedback-heading': 'Selecionar feedback',
    'ai-smart-button.feedback-action.submit-button-label': 'Enviar feedback',
    'ai-smart-button.feedback-action.suggest-improvement-option': 'Sugerir uma melhoria',
    'ai-smart-button.feedback-action.title': 'Dar feedback',
    'ai-smart-button.feedback-item.icon-label': "\xcdcone de feedback",
    'ai-smart-button.reference.close-button-label': 'Fechar'
};

});


//# sourceMappingURL=pt_BR.9dcd6d4e.js.map
